import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const MovimentoEstoqueList = (props) => <DefaultDataTable data={props} />
